import axios from './mojiokoApi';

export default {
  async getLatestClient() {
    const res = await axios.get('/api/versions/latestclient');
    return res.data;
  }
};
